import masterdataApi from "./devapis/masterdata.api";
import myleadsapi from "./devapis/myleadsapi.api";
import offlineleads from "./devapis/offlineleads.api";
import myearnings from "./devapis/myearnings.api";
import leadsApi from "./devapis/leads.api";
import applicationsApi from "./devapis/applications.api";
import payoutApi from "./devapis/payout.api";
import dashboardApi from "./devapis/dashboard.api";
import employeeApi from "./devapis/employee.api";
import connectorApi from "./devapis/connector.api";
import agentApi from "./devapis/agent.api";
import opsapplicationsApi from "./devapis/opsapplications.api";

export default {
    ...masterdataApi,
    ...myleadsapi,
    ...offlineleads,
    ...myearnings,
    ...leadsApi,
    ...applicationsApi,
    ...payoutApi,
    ...dashboardApi,
    ...employeeApi,
    ...connectorApi,
    ...agentApi,
    ...opsapplicationsApi,

    HEARTBEAT: {
        url: '/api/v1/heartbeat',
        method: "get",
    },
    EMPLOYEE_LOGIN: {
        url: "/api/v1/employee/authentication/credential/login",
        method: "post"
    },
    GET_EMPLOYEE: {
        url: "/api/v1/employee/authentication/me",
        method: "get"
    },
    EMPLOYEE_OTP_LOGIN: {
        url: "/api/v1/employee/authentication/otp/{mobile_number}",
        method: "get"
    },
    EMPLOYEE_OTP_LOGIN_VERIFY: {
        url: "/api/v1/employee/authentication/verify",
        method: "post"
    },
    REFRESH_TOKEN: {
        url: "/api/v1/employee/authentication/credential/refresh",
        method: "post"
    },
    EMPLOYEE_PASSWORD_RESET: {
        url: "/api/v1/employee/authentication/change",
        method: "put"
    },
    EMPLOYEE_GENERATE_TEMPORARY_PASSWORD: {
        url: "/api/v1/employee/authentication/reset/{email_address}",
        method: "put"
    },
    LOGOUT: {
        url: "/api/v1/auth/logout",
        method: "post"
    },

    // MY PROFILE
    GET_DIGIREP: {
        url: "/api/v1/profile",
        method: "get"
    },
    GET_DIGIREP_OPEN: {
        url: "/api/v1/profile/open/{profileId}",
        method: "get"
    },
    CREATE_DIGIREP: {
        url: "/api/v1/profile",
        method: "post",
    },
    GET_MY_INFO: {
        url: "/api/v1/profile/myinfo",
        method: "get",
    },
    GET_SINGLE_PROFILE_INFO: {
        url: "/api/v1/profile/{profileId}",
        method: "get",
    },

    // CUSTOMER KYC
    KYC_SEND_OTP: {
        url: "/api/v1/kyc/profile/mobile/request",
        method: "post"
    },
    KYC_VERIFY_OTP: {
        url: "/api/v1/kyc/profile/mobile/verify",
        method: "post"
    },
    GET_CUSTOMER_PAN_DETAILS: {
        url: "/api/v1/kyc/profile/pan/request",
        method: "post"
    },
    VERIFY_CUSTOMER_PAN: {
        url: "/api/v1/kyc/profile/pan/verify",
        method: "post"
    },
    DELETE_CUSTOMER_PAN: {
        url: "/api/v1/kyc/profile/pan/{profileId}",
        method: "delete"
    },
    GET_CUSTOMER_AADHAR_DETAILS: {
        url: "/api/v1/kyc/profile/aadhar/request",
        method: "post"
    },
    VERIFY_CUSTOMER_AADHAR: {
        url: "/api/v1/kyc/profile/aadhar/verify",
        method: "post"
    },
    DELETE_CUSTOMER_AADHAR: {
        url: "/api/v1/kyc/profile/aadhar/{profileId}",
        method: "delete"
    },
    GET_DIGILOCKER_URL_FOR_USER_CONSENT: {
        url: "/api/v2/kyc/profile/aadhar/digilockerurl",
        method: "post"
    },
    GET_AADHAR_CONSENT_RESPONSE: {
        url: "/api/v2/kyc/profile/aadhar/check/{requestId}",
        method: "put"
    },
    PROFILE_UPLOAD_DOCS: {
        url: "/api/v1/kyc/profile/doc-upload",
        method: "put"
    },
    SEND_AGREEMENT_FOR_ESIGN: {
        url: "/api/v1/kyc/profile/agreement/{profileId}",
        method: "post"
    },

    // CUSTOMER AUTHENTICATION
    CUSTOMER_SIGNUP_VERIFY: {
        url: "/api/v1/customer-auth/signup/verify",
        method: "post"
    },
    CUSTOMER_SIGNIN_REQUEST: {
        url: "/api/v1/customer-auth/signin/request/{mobileNumber}",
        method: "get"
    },
    CUSTOMER_SIGNIN_VERIFY: {
        url: "/api/v1/customer-auth/signin/verify",
        method: "post"
    },
    CUSTOMER_SIGNUP_COMPLETE: {
        url: "/api/v1/customer/signup/complete",
        method: "post"
    },
    CUSTOMER_INFORMATION: {
        url: "/api/v1/customer",
        method: "get"
    },
    // FILE API'S
    FILE_UPLOAD: {
        url: "/api/v1/files/upload/{foldername}",
        method: "post"
    },
    GET_FILE_METADATA: {
        url: "/api/v1/files/metadata/{fileId}",
        method: "get"
    },
    GET_FILE_THUMBNAIL: {
        url: "/api/v1/files/thumbnail/{fileId}",
        method: "get"
    },
    FILE_DOWNLOAD: {
        url: "/api/v1/files/download/{fileId}",
        method: "get"
    },
    THUMBNAIL_DOWNLOAD: {
        url: "/api/v1/files/thumbnail/{fileId}",
        method: "get"
    },
    DELETE_FILE: {
        url: "/api/v1/files/remove/{fileId}",
        method: "delete"
    },

    // VAS - WALLET
    VAS_RECHARGE: {
        url: "/api/v1/vas/wallet/recharge",
        method: "post"
    },
    GET_USER_BALANCE: {
        url: "/api/v1/vas/wallet/balance",
        method: "get"
    },
    GET_PAST_TRANSACTION: {
        url: "/api/v1/vas/wallet/transaction",
        method: "get"
    },

    // VAS - SERVICES
    VAS_GET_PAN_DETAILS: {
        url: "/api/v1/vas/services/pan",
        method: "post"
    },
    VAS_GET_AADHAR_INFO: {
        url: "/api/v1/vas/services/aadhar/request",
        method: "post"
    },
    VAS_AADHAR_VERIFY: {
        url: "/api/v1/vas/services/aadhar/verify",
        method: "post"
    },
    // REQUEST
    CONNECTOR_REQUEST_RECHARGE: {
        url: "/api/v1/request-recharge",
        method: "post"
    },
    GET_REQUEST_RECHARGE: {
        url: "/api/v1/request-recharge",
        method: "get"
    },
    GET_REQUEST_RECHARGE_BY_ID: {
        url: "/api/v1/request-recharge/{rechargeId}",
        method: "get"
    },
    UPDATE_REQUEST_RECHARGE_BY_ID: {
        url: "/api/v1/request-recharge/{rechargeId}",
        method: "put"
    },
    SEND_REQUEST_RECHARGE_OTP: {
        url: "/api/v1/request-recharge/processing/request/{rechargeId}",
        method: "get"
    },
    VERIFY_REQUEST_RECHARGE_OTP: {
        url: "/api/v1/request-recharge/processing/verify/{rechargeId}",
        method: "put"
    },
    REJECT_REQUEST_RECHARGE_OTP: {
        url: "/api/v1/request-recharge/reject/{rechargeId}",
        method: "put"
    },

    // SERVICE UTILIZATION
    GET_SERVICE_UTILIZATION: {
        url: "/api/v1/service-utilization",
        method: "get"
    },

    // MASTER SUBSCRIPTION
    GET_MASTER_SUBSCRIPTION: {
        url: "/api/v1/master-subscription",
        method: "get"
    },

    // QR CODE
    GENERATE_QR_CODE: {
        url: "/api/v1/qrcode/generate",
        method: "post"
    },
    GET_QR_CODE: {
        url: "/api/v1/qrcode/download",
        method: "get"
    },

}
